import { Message } from 'react-intl'

import { SmsVerifyError, SmsVerifyResponse } from '../../constants'
import messages from '../../i18n'

interface ErrorVariant {
  btn?: Message
  text: Message
  title: Message
}

export const mapResponseToErrorResponse = (
  response?: SmsVerifyResponse
): SmsVerifyError | undefined => {
  switch (response) {
    case SmsVerifyResponse.Ko:
      return SmsVerifyError.Ko
    case SmsVerifyResponse.Locked:
      return SmsVerifyError.Locked
    case SmsVerifyResponse.TimedOut:
      return SmsVerifyError.TimedOut
    default:
      return undefined
  }
}

export const variants: Record<SmsVerifyError, ErrorVariant> = {
  [SmsVerifyError.Ko]: {
    btn: messages.smsVerify.errors.ko.btn,
    title: messages.smsVerify.errors.ko.title,
    text: messages.smsVerify.errors.ko.text,
  },
  [SmsVerifyError.Locked]: {
    title: messages.smsVerify.errors.locked.title,
    text: messages.smsVerify.errors.locked.text,
    btn: messages.smsVerify.errors.locked.btn,
  },
  [SmsVerifyError.TimedOut]: {
    btn: messages.smsVerify.errors.timeout.btn,
    title: messages.smsVerify.errors.timeout.title,
    text: messages.smsVerify.errors.timeout.text,
  },
}
